import { render, staticRenderFns } from "./EmBrevePage.vue?vue&type=template&id=6162e064&scoped=true"
import script from "./EmBrevePage.vue?vue&type=script&lang=js"
export * from "./EmBrevePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6162e064",
  null
  
)

export default component.exports